<div class="card">
  <div class="card-body">
    <div class="row d-flex justify-content-between px-1">
      <div>
        <h4>{{ "MENU.WORKDAY_USER_REPORT" | translate }} {{ month | titlecase }}</h4>
      </div>
      <div *ngIf="report" [ngClass.xl]="'ml-1'">
        <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-success" *ngIf="report && report.status === 2">{{ "APPROVED" | translate }}</span>
        <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-danger" *ngIf="report && report.status === 3">{{ "REJECTED" | translate }}</span>
        <span [ngClass.sm]="'mt-1'" class="font-small-3 badge badge-warning" *ngIf="report && report.status === 1">{{ "PENDING" | translate }}</span>
      </div>
    </div>

    <div class="row">
      <!--Potrai inviare il rapportino dal-->
      <div class="col-12" *ngIf="lockReport">
        <span>
          <i data-feather="help-circle" class="text-info"></i>
          {{ "UNLOCK_WORKDAY_REPORT_LABEL" | translate }}
          {{ this.unlockStaffDate && this.unlockStaffDate.length > 0 ? this.unlockStaffDate : _utilService.formatDate(unlockDay, "DD MMMM") }}</span
        >
      </div>
      <!--Puoi inviare il rapportino-->
      <div class="col-12" *ngIf="this.currentDay == _utilService.formatDate(unlockDay, 'DD MMMM') && report && report.status !== 2 && report.status !== 1 && report.status !== 3">
        <span><i data-feather="check-circle" class="text-success"></i> {{ "NOW_YOU_CAN_SEND_YOUR_REPORT" | translate }}</span>
      </div>
      <!--Invia il tuo rapportino prima della scadenza-->
      <div class="col-12" *ngIf="(!report && !lockReport) || (!lockReport && report && report.status !== 2 && report.status !== 1 && report.status !== 3)">
        <span><i data-feather="alert-octagon" class="text-danger"></i> {{ "SUBMIT_REPORT_BEFORE_DEADLINE" | translate }}</span>
      </div>
      <!--Il tuo rapportino è stato rifiutato rinvialo prima della fine del mese.-->
      <div class="col-12" *ngIf="report && report.status === 3">
        <span><i data-feather="alert-octagon" class="text-danger"></i> {{ "RESEND_REPORT_REJECTED" | translate }}</span>
      </div>
      <!--Hai inviato il rapportino-->
      <div class="col-12" *ngIf="report && (report.status === 1 || report.status === 2)">
        <span><i data-feather="check-circle" class="text-success"></i> {{ "YOU_SENDED_REPORT" | translate }}</span>
      </div>
    </div>
  </div>
</div>
